import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    loadPaymentMethodsStart,
    loadPaymentMethodsSuccess,
    loadPaymentMethodsError
} from '../actions/load-payment-methods';
import { ILoadPaymentMethods, ILoadPaymentMethodResponse } from '../state/get-All-Payment-Methods';
import { Http } from '@telstra-connect/utils';
import { getRequestIdForAlerts } from '@telstra-connect/utils/http/common/headers';
import api from '../version';


export function loadPaymentMethodsList(cidn: string, accountId: string, b2bUid: string):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(loadPaymentMethodsStart());
        const appendHeader =  Http.get<ILoadPaymentMethodResponse>({
            url: `/billing/${api.version}/account/`
            + `${accountId}/getAllPaymentMethod?b2bUid=${b2bUid}`,
            customHeaders: {
                'company-id': cidn,
                'request-id': getRequestIdForAlerts(cidn)
            },
            state: getState()
        })
        return appendHeader.then((result: ILoadPaymentMethodResponse) => {
            const response: ILoadPaymentMethods  = result.data;
            dispatch(loadPaymentMethodsSuccess(response));
        })
            .catch((error) => {
                dispatch(loadPaymentMethodsError('Error loading payment method details.', error.code));
            });
    };
}
